import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import { Observable } from 'rxjs';
import { PartnershipDataGroup, RelationshipDataGroup } from './models/UserRelationship';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetGroupService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  find(): Observable<PartnershipDataGroup[]> {
    const api = (<any>_GlobalNS).api.partner.relationshipGroupById;
    return this._http.get<any>(`${api}`, {});
  }

  // Logged in PersonId is used for this service, not passing personid param expicilty
  findMasterByPerson(): Observable<PartnershipDataGroup[]> {
    const api = (<any>_GlobalNS).api.user.relationshipGroupByPerson;
    return this._http.get<any>(`${api}`, {});
  }

 // Logged in PersonId is used for this service, not passing personid param expicilty
  findByPerson(): Observable<RelationshipDataGroup[]> {
    const api = (<any>_GlobalNS).api.user.relationshipGroupByPerson;
    return this._http.get<any>(`${api}&groupOnly=true`, {});
  }

  remove(relationshipGroupId: number): Observable<any> {
    const api = (<any>_GlobalNS).api.partner.deleteRelationshipGroup;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&RelationshipGroupId=${relationshipGroupId}&eqrf=${eqrf}`, this.httpOptions);
  }

  create(relationshipGroup: RelationshipDataGroup): Observable<any> {
    const api = (<any>_GlobalNS).api.partner.relationshipGroup;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, relationshipGroup, this.httpOptions);
  }

  assetGroupNameExists(RelationshipGroupName: string, relationshipId: number): Observable<any> {
    const api = (<any>_GlobalNS).api.partner.assetGroupNameExists;
    const params = new HttpParams().set('RelationshipGroupName', RelationshipGroupName).set('relationshipId', relationshipId.toString());
    return this._http.get<any>(`${api}`, { params });
  }

}
